/* eslint-disable */
// chakra imports
import { Box, useColorModeValue, Image, Text } from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import SidebarContent from "./SidebarContent";
import logo_outstand from '../../assets/img/logo_outstand_branco.png';

const scrollBarStyle = `
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #a0aec061; 
    border-radius: 10px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #a0aec0; 
  }
`;

function Sidebar(props) {
  const mainPanel = React.useRef();
  let variantChange = "0.2s linear";
  const [logoBase64, setLogoBase64] = useState(null);

  const { logoText, routes, sidebarVariant } = props;

  useEffect(() => {
    const storedLogo = localStorage.getItem('logo_base_64');
    if (storedLogo) {
      setLogoBase64(storedLogo);
    }
  }, []);

  const routesFinal = routes.filter(
    (rota) => 
      rota.path !== "/AudioPage" && 
      rota.path !== "/perguntas/:Audit_id" && 
      rota.path !== "/metadados/:idtranscript_scheduller" &&
      rota.path !== "/classificationsinsights/:idtranscript_scheduller" &&
      rota.path !== "/campanhas/:description/:idcampanhas"
  );

  const sidebarBg = useColorModeValue("brand.700", "gray.700");

  return (
    <Box ref={mainPanel}>
      <style>{scrollBarStyle}</style>
      <Box>
        <Box
          bg={sidebarBg}
          transition={variantChange}
          w="260px"
          maxW="260px"
          h="100vh"
          ps="10px"
          pe="10px"
          display="flex" // Torna o conteúdo flexível
          flexDirection="column" // Organiza os filhos verticalmente
        >
          &nbsp; {/* Linha em branco */}
           <Text
              fontSize="4xl" // Tamanho da fonte
              fontWeight="bold" // Negrito
              color="white" // Letras brancas
              textAlign="center" // Centraliza o texto no meio
              textShadow="2px 2px 4px rgba(0, 0, 0, 0.7)" // Adiciona sombra preta
              mt="-8px" // Margem superior
              mb="-3px" // Margem inferior
            >
              Customer Voice
            </Text>
          {logoBase64 ? (
            <Image
              src={logoBase64}
              boxSize="150px"
              mb="-40px"
              mx="auto"
            />
          ) : (
            <Image
              src={require('../../assets/img/logo_speech.png')}
              boxSize="150px"
              mb="-40px"
              mx="auto"
            />
          )}
          <SidebarContent
            routes={routesFinal}
            display="none"
            sidebarVariant={sidebarVariant}
          />
           <Image
              src={logo_outstand}
              boxSize="200px" // Define o tamanho da imagem
              objectFit="contain" // Garante que a imagem seja contida sem esticar
              mt="auto" // Empurra a imagem para o final
              mx="auto" // Centraliza a imagem horizontalmente
              mt="-50px" // Margem superior
              mb="-40px" // Margem inferior
              ml="3"
            />
          
        </Box>
      </Box>
    </Box>
  );
}

export default Sidebar;
